import axios from 'axios'
import store from "../store";

let api = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:8000/"
      : "https://hermes-fn.herokuapp.com/",
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use (
  function (config) {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
      config.headers.Authorization = `Bearer ${ user.token }`
    }
    return config;
  },
  function (error) {
    return Promise.reject (error);
  }
);

api.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    onResponse(response);
    return response
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    onError(error);
    return Promise.reject(error);
  });

// Run a for loop through the possible response types.  If one hits then execute.
function onResponse(response) {
  if (response.config.method === 'patch' || response.config.method === 'put') {
    store.dispatch('setSnackBar', 'Updated');
  } else if (response.config.method === 'post') {
    store.dispatch('setSnackBar', 'New')
  } else if (response.config.method === 'delete') {
    store.dispatch('setSnackBar', 'Deleted!')
  }
}

function onError(error) {
  // eslint-disable-next-line no-console
  console.log(error.response.status);
  if (error.response.status === 400) {
    store.dispatch("setSnackBar", error.response.data);
  } else if (error.response.status === 401) {
    store.dispatch("setSnackBar", "No permissions.  You might need to login.");
  } else if (error.response.status === 403) {
    store.dispatch("setSnackBar", "You might not be logged in.");
  } else if (error.response.status === 404) {
    store.dispatch("setSnackBar", "Looks like a bad link! There's nothing here.");
  } else if (error.response.status === 422) {
    store.dispatch("setSnackBar", error.response.data);
  } else if (error.response.status === 500) {
    store.dispatch("setSnackBar", "Server error. The worst possible thing.");
  } else {
    store.dispatch('setSnackBar', "No error code found. That's not good.")
  }
}

export default api;